import { useDomainTracking } from '../hooks/use-domain-tracking';
import { cn } from '../utils/cn';
import { buttonClasses } from './button';

export function DomainRestriction() {
  const { info } = useDomainTracking();
  if (!(info.isEmbedded && !info.allowedDomain)) return null;
  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <div className="rounded-xl border border-hilevel-red/30 bg-hilevel-red/5 p-8 text-center">
        <h4 className="text-xl font-semibold text-hilevel-slate">Access Restricted</h4>
        <p className="mt-3 text-sm text-hilevel-slate">
          This budget calculator is not authorised to be embedded on this domain (
          <strong>{info.parentDomain}</strong>).
        </p>
        <p className="mt-2 text-sm text-hilevel-slate">
          If you are a distributor and would like to embed this tool on your website, please contact
          us to request access.
        </p>
        <a
          href="https://budget.iqd-pro.com"
          target="_blank"
          rel="noreferrer"
          className={cn('mt-5', buttonClasses({ size: 'lg' }))}
        >
          Visit Official Budget Calculator
        </a>
      </div>
    </div>
  );
}
